import { ArrowRight, Lightbulb } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { languages } from "../lib/languages";
import { situations } from "../lib/travel";

export function TravelPage() {
  const navigate = useNavigate();
  const [target, setTarget] = useState("en");
  const [selected, setSelected] = useState<(typeof situations)[number] | null>(null);
  function usePhrase(phrase: string) {
    navigate(`/app/translate?text=${encodeURIComponent(phrase)}&target=${encodeURIComponent(target)}`);
  }
  return (
    <div className="page-stack travel-page">
      <div className="page-title"><div><span className="section-kicker">LingoSound Viaje</span><h1>Tu copiloto en cada situación</h1></div></div>
      <div className="travel-language"><span>Traducir al</span><select value={target} onChange={(event) => setTarget(event.target.value)}>{languages.filter((language) => language.code !== "es").map((language) => <option key={language.code} value={language.code}>{language.flag} {language.name}</option>)}</select></div>
      <div className="travel-tip"><Lightbulb size={21} /><p><strong>Consejo LingoSound</strong><span>Elegí dónde estás y te damos las frases exactas para resolverlo.</span></p></div>
      <div className="situation-grid">
        {situations.map((situation) => {
          const Icon = situation.icon;
          return <button key={situation.id} onClick={() => setSelected(situation)}><span><Icon size={24} /></span><strong>{situation.title}</strong><small>{situation.subtitle}</small><ArrowRight size={17} /></button>;
        })}
      </div>
      {selected && (
        <div className="sheet-backdrop" onClick={() => setSelected(null)}>
          <section className="phrase-sheet" onClick={(event) => event.stopPropagation()}>
            <div className="sheet-handle" />
            <span className="section-kicker">{selected.title}</span><h2>¿Qué necesitás decir?</h2>
            <div className="phrase-list">{selected.phrases.map((phrase) => <button key={phrase} onClick={() => usePhrase(phrase)}><span>{phrase}</span><ArrowRight size={18} /></button>)}</div>
            <button className="button secondary" onClick={() => navigate("/app/translate")}>Decir otra cosa</button>
          </section>
        </div>
      )}
    </div>
  );
}
